import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

class SwipeCards {
  constructor(el) {
    this.el = el
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.initSwiper()
  }

  bindUI() {
    this.ui = {}
    this.ui.$button = this.el.querySelector('.js-button')
    this.ui.$images = [...this.el.querySelectorAll('.js-looks-image')]
    this.reversedArray = this.ui.$images.reverse()
    this.start = this.ui.$button ? 60 : 100
    this.index = 1
  }

  initSwiper() {
    const tl = gsap.timeline({
      paused: true,
      scrollTrigger: {
        trigger: this.el,
        start: `top ${this.start}px`,
        end: "bottom top",
        scrub: true,
        pin: true
      }
    })


    this.reversedArray.forEach((image, index) => {
      if(this.index < this.reversedArray.length) {
        tl.to(this.reversedArray[index], { yPercent: -150, delay: this.index * 1.5 })
      }
      this.index++
    });

    ScrollTrigger.create({
      trigger: this.el,
      start: `top ${this.start}px`,
      end: "bottom top",
      scrub: true,
      pin: true,
      onEnter: () => {
        tl.play();
      },
      onLeave: () => {
        tl.pause()
      }
    })
  }
}

export default SwipeCards


